import request from '@/utils/request'
import URL from './urlTranslator'

export function getUserGroupsFunc(params) {
  return request({
    url: URL.sys.getUserGroupsUrl,
    method: 'get',
    params
  })
}

